import { render, staticRenderFns } from "./AddOrEditMediation.vue?vue&type=template&id=24487747&scoped=true&"
import script from "./AddOrEditMediation.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditMediation.vue?vue&type=script&lang=ts&"
import style0 from "./AddOrEditMediation.vue?vue&type=style&index=0&id=24487747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24487747",
  null
  
)

/* custom blocks */
import block0 from "./AddOrEditMediation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField,VTextarea})
